// Ajustes > Calendário (0.67, texto 05 D3): em que dia a semana começa e o formato da hora.
import { setDoc, useDoc } from '../../store/store';
import { t } from '../../lib/i18n';
import { Bloco, Divisor, LinhaOpcoes } from '../../components/ajustes/Linhas';

export default function Calendario() {
  const aj = useDoc('ajustes');
  return (
    <Bloco>
      <LinhaOpcoes icone="📅" titulo={t('A semana começa na')} valor={aj.semanaComeca ?? 'seg'}
        opcoes={[['seg', t('Segunda')], ['dom', t('Domingo')]]} onEscolher={v => setDoc('ajustes', d => ({ ...d, semanaComeca: v }))} />
      <Divisor />
      <LinhaOpcoes icone="🕐" titulo={t('Formato da hora')} valor={aj.hora12 ? '12' : '24'}
        opcoes={[['24', t('24 horas (14:30)')], ['12', t('12 horas (2:30 PM)')]]} onEscolher={v => setDoc('ajustes', d => ({ ...d, hora12: v === '12' }))} />
    </Bloco>
  );
}
